"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEIGHT_ARRAY = exports.SIZE_ARRAY = exports.WEIGHTS = exports.SIZES = void 0;
exports.SIZES = new Array("text-xs", "text-sm", "text-base", "text-lg", "text-xl", "text-2xl", "text-3xl", "text-4xl", "text-5xl", "text-6xl", "text-7xl", "text-8xl", "text-9xl");
exports.WEIGHTS = new Array("font-thin", "font-extralight", "font-light", "font-normal", "font-medium", "font-semibold", "font-bold", "font-extrabold", "font-black");
const SIZE_ARRAY = () => {
    const _sizes = [];
    for (let i = 0; i < exports.SIZES.length; i++) {
        _sizes.push({ value: String(i), label: String(i + 1) });
    }
    return _sizes;
};
exports.SIZE_ARRAY = SIZE_ARRAY;
const WEIGHT_ARRAY = () => {
    const _weights = [];
    for (let i = 0; i < exports.WEIGHTS.length; i++) {
        _weights.push({ value: String(i), label: String(i + 1) });
    }
    return _weights;
};
exports.WEIGHT_ARRAY = WEIGHT_ARRAY;
